export default __webpack_public_path__ + "static/media/hero.5142a84b.png";